import {
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState } from "react";
import AppButton from "../shares/AppButton";
import { OFFRE_EMPLOIS } from "../offre/DataOffreEmploies";
import AppTimeLine from "../shares/AppTimeline";
import { display } from "@mui/system";

const MesDemande = () => {
  const [expandedGrids, setExpandedGrids] = useState([]);
  const [offresEmploies, setOffreEmplois] = useState(OFFRE_EMPLOIS);
  const toggleExpandOffre = (idx) => {
    let ids = expandedGrids.slice();
    if (expandedGrids.includes(idx)) {
      const index = ids.indexOf(idx);
      if (index > -1) {
        ids.splice(index, 1);
      }
    } else {
      ids.push(idx);
    }
    setExpandedGrids(ids);
  };

  const MAX_LINE = 3;
  return (
    <Grid container display={"flex"} flexDirection={"row"} mr={2}>
      <Grid item xs={12}>
        <Grid item  lg={10} p={3}>
          <TextField
            id="reacherche"
            size="small"
            fullWidth
            placeholder="Recherche"
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchIcon />
                </IconButton>
              ),
            }}
          />
        </Grid>
        <CardHeader title="Historique de mes demandes" />
        {offresEmploies.map((item, index) => (
          <Paper elevation={0} key={index}>
            <Grid item xs={12} m={1} key={`k-${index}`} minHeight={100}>
              <CardContent>
                <Grid container>
                  <Grid item xs={12} lg={expandedGrids.includes(index) ? 9 : 12}>
                    <CardHeader
                      title={item.titre}
                      titleTypographyProps={{ variant: "h5" }}
                      subheader={`Publié le: ${item.date_pulication}`}
                      subheaderTypographyProps={{ variant: "caption" }}
                      action={
                        <Grid mt={1}>
                          <Chip
                            label={`Date de cloture: ${item.date_cloture}`}
                            color="warning"
                            size="small"
                          />
                        </Grid>
                      }
                    />
                    <Grid>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        textAlign={"justify"}
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: expandedGrids.includes(index)
                            ? "unset"
                            : MAX_LINE,
                        }}
                        component={"div"}
                      >
                        {item.description}
                        <br />
                        <span
                          style={{
                            display:
                              item.qualification.length > 0 ? "block" : "none",
                          }}
                        >
                          <br />
                          <b>
                            <u>Qualification:</u>
                          </b>
                        </span>
                        <ul>
                          {item.qualification.map((qu, index) => (
                            <li key={index}>{qu.diplome}</li>
                          ))}
                        </ul>
                        <span
                          style={{
                            display:
                              item.experience_exige.length > 0
                                ? "block"
                                : "none",
                          }}
                        >
                          <br />
                          <b>
                            <u>Experiences:</u>
                          </b>
                        </span>
                        <ul>
                          {item.experience_exige.map((qu, index) => (
                            <li
                              key={index}
                            >{`${qu.domaine} avec ${qu.duree} ${qu.unite} d'experience`}</li>
                          ))}
                        </ul>
                        <span
                          style={{
                            display:
                              item.autre_critere_exige.length > 0
                                ? "block"
                                : "none",
                          }}
                        >
                          <br />
                          <b>
                            <u>Atouts:</u>
                          </b>
                        </span>
                        <ul>
                          {item.autre_critere_exige.map((qu, index) => (
                            <li key={index}>{`${qu.critere} `}</li>
                          ))}
                        </ul>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={3}
                    display={expandedGrids.includes(index) ? "flex" : "none"}
                  >
                    <Grid>
                      <CardHeader
                        title="Status de l'offre"
                        titleTypographyProps={{ variant: "h6" }}
                        subheader={
                          <span>
                            <AppTimeLine id_offre={item.id_offre} />
                          </span>
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions
                sx={
                  {
                    /* justifyContent: "flex-end" */
                  }
                }
              >
                <AppButton
                  style={{display: "none"}}
                  size="small"
                  variant="contained"
                  text={"Modifier candidataure"}
                />
                <AppButton
                  size="small"
                  style={{
                    textTransform: "initial",
                    display:
                      MAX_LINE < item.description.split("\n").length
                        ? "block"
                        : "none",
                  }}
                  onClick={() => toggleExpandOffre(index)}
                  text={
                    expandedGrids.includes(index) ? "Voir moins" : "Voir plus"
                  }
                />
              </CardActions>
            </Grid>
            <Divider variant="middle" flexItem sx={{ m: 1 }} />
          </Paper>
        ))}
      </Grid>
    </Grid>
  );
};

export default MesDemande;
